import React from 'react'

interface MerchantProductLoadingSkeletonProps {
  count?: number
}

function MerchantProductLoadingSkeleton({ count = 3 }: MerchantProductLoadingSkeletonProps) {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="tw-rounded-xl tw-bg-white dark:tw-bg-slate-800/60 tw-p-3 tw-shadow-sm tw-animate-pulse tw-border tw-border-slate-200/60 dark:tw-border-slate-700/60"
        >
          {/* Card Content Skeleton */}
          <div className="tw-flex tw-gap-3">
            {/* Image Skeleton */}
            <div className="tw-h-10 tw-w-10 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded-lg tw-flex-shrink-0"></div>
            
            {/* Content Skeleton */}
            <div className="tw-flex-1 tw-space-y-2">
              {/* Title skeleton */}
              <div className="tw-h-4 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded tw-w-3/4"></div>
              
              {/* Brand/SKU skeleton */}
              <div className="tw-h-3 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded tw-w-1/2"></div>
              
              {/* Price/Stock skeleton */}
              <div className="tw-flex tw-items-center tw-gap-3 tw-mt-2">
                <div className="tw-h-6 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded tw-w-24"></div>
                <div className="tw-h-4 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded tw-w-16"></div>
              </div>
              
              {/* Bottom section with metrics */}
              <div className="tw-pt-3 tw-mt-1 tw-border-t tw-border-slate-100 dark:tw-border-slate-700/50">
                <div className="tw-flex tw-items-center tw-justify-between">
                  {/* Metrics skeleton */}
                  <div className="tw-flex tw-items-center tw-gap-3">
                    <div className="tw-h-3 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded tw-w-12"></div>
                    <div className="tw-h-3 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded tw-w-16"></div>
                  </div>
                  {/* Quality badge skeleton */}
                  <div className="tw-h-5 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded-full tw-w-16"></div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Action Buttons Skeleton */}
          <div className="tw-border-t tw-border-slate-200 dark:tw-border-slate-700 tw-mt-3 tw-pt-2 tw-flex tw-gap-2">
            <div className="tw-h-9 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded-lg tw-flex-1"></div>
            <div className="tw-h-9 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded-lg tw-flex-1"></div>
            <div className="tw-h-9 tw-bg-gray-200 dark:tw-bg-slate-700 tw-rounded-lg tw-flex-1"></div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MerchantProductLoadingSkeleton